<pf-dropdown hide-arrow class="user-menu" [isOpen]="isOpen">
    <div slot="button">
        <a class="nav-link">
            <pf-image
                [src]="user != null ? user.picture : ''"
                fallback-src="assets/img/default-profile.png"
                class="user-image-small"
                width="25"
                height="25"
                alt="User Image"
                rounded
                (click)="showDropdown()"
            ></pf-image>
        </a>
    </div>
    <div slot="menu">
        <li class="user-header bg-primary">
            <pf-image
                [src]="user != null ? user.picture : ''"
                fallback-src="assets/img/default-profile.png"
                class="user-image-big"
                alt="User Image"
                width="90"
                height="90"
                rounded
            ></pf-image>

            <p>
                <span>{{user != null ? user.email : ''}}</span>
            </p>
        </li>
        <!-- Menu Footer-->
        <li class="user-footer">
            <a [routerLink]="['/profile']" class="btn btn-default btn-flat" (click)="showDropdown()">
                Profile
            </a>
            <a (click)="logout()" class="btn btn-default btn-flat float-right">
                Sign out
            </a>
        </li>
    </div>
</pf-dropdown>
